import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
// Import dla EFEKTU UBOCZNEGO: pakiety vertykalne rejestruja sie przy imporcie,
// a bez nich `compileSceneDraft` w przegladarce pracowalby w trybie
// zdegradowanym (src/shared/verticals/index.ts § naglowek).
import '@shared/verticals';
import { router } from './router';
import { createQueryClient } from './lib/query';
import { applyTheme, readStoredTheme } from './lib/branding';
import './index.css';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('#root not found in index.html');
}

// Motyw ustawiamy przed pierwszym renderem, zeby nie bylo mrugniecia.
applyTheme(readStoredTheme());

const queryClient = createQueryClient();

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
